module.exports = __webpack_public_path__ + "media/format-selector/online_event@1x-9c0a26fe.png";